import React, { useState, useContext } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd';
import MasterPage from '@components/MasterPage';
import {IProps, IState} from './types';
import * as S from './styles';
import { useHistory, useLocation } from 'react-router';
import WarningScreen from '@components/WarningScreen';
import ListTemplate from '../Templates/components/ListTemplate';
import { TemplatesProvider } from '@utils/DOIgnition/TemplatesContext';
import StudioContent from './components/StudioContent';
import CreateNew from './components/CreateNew';
import { StudioContext } from '@utils/DOIgnition/StudioContext';

const StudioDashboard:React.FC<IProps> = (props) => {
  const {searching, setSearching, filtering, setFiltering, filtersTemplates, setFiltersTemplates} = useContext(StudioContext);
  const [hasDesigns, setHasDesigns] = useState(false);
  const [isLookingForDesigns, setIsLookingForDesigns] = useState(true);

  const history: any = useHistory();

  const [open, setOpen] = useState(false);
  const [warningOptions, setWarningOptions] = useState({
    title: '',
    subtitle: '',
    actionTitle: '',
    actionFunction: () => {},
    closeActionTitle: '',
    errorNote: '',
    errorArguments: [],
  });

  const handleWarningScreen = (openValue:boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any) => {
    setOpen(openValue);
    setWarningOptions({
      title: title,
      subtitle: subtitle,
      actionTitle: actionTitle,
      actionFunction: actionFunction,
      closeActionTitle: closeActionTitle,
      errorNote: errorNote,
      errorArguments: errorArguments,
    })
  }

  const handleCreateNewDesign = () => {
    history.push({pathname: '/editor'});
  }
  
  return (
    <S.Root>
      <WarningScreen
        open={open}
        setOpen={setOpen}
        options={warningOptions}
      />
      <MasterPage
        pageIndex={1}
        newTitle={hasDesigns || isLookingForDesigns ? "" : searching?'Studio Dashboard':" "}
        newHeight={hasDesigns || isLookingForDesigns ? 300 : 521}
        renderAction={() => (
          hasDesigns &&
          <S.HeaderCreateButton>
            <CreateNew position={"right"} setFiltering={setFiltering} setFiltersTemplates={setFiltersTemplates}/>
          </S.HeaderCreateButton>
      )}
      >
        <S.Header
          heightValue={searching || hasDesigns || isLookingForDesigns ? '0px' : '273px'}
          opacityValue={searching || hasDesigns || isLookingForDesigns ? '0' : '1'}
          hasDesigns={hasDesigns}
        >
          <S.Title>
            Welcome to Design Studio
          </S.Title>
          <S.Subtitle>
            Start creating something great, it’s easy to do!
          </S.Subtitle>
          <S.Subtitle>
            Create something new from a blank canvas or search our template to get started
          </S.Subtitle>
          <S.CreateButtonContainer>
            <CreateNew position={"center"}/>
          </S.CreateButtonContainer>
        </S.Header>

        <DndProvider backend={HTML5Backend}>
          <TemplatesProvider hasDesigns={hasDesigns} isLookingForDesigns={isLookingForDesigns} location='studio'>
            <ListTemplate 
                handleWarningScreen={handleWarningScreen}
                openModal={open}
                onSearch={(val:boolean)=>setSearching(val)}
                onFiltering={(val:boolean)=>setFiltering(val)}
                initialfilters={filtersTemplates}
            />
            <StudioContent
              hasDesigns={hasDesigns}
              setHasDesigns={setHasDesigns}
              shouldDisplay={!searching && !filtering}
              handleWarningScreen={handleWarningScreen}
              isLookingForDesigns={isLookingForDesigns}
              setIsLookingForDesigns={setIsLookingForDesigns}
            />
          </TemplatesProvider>
        </DndProvider>
        
      </MasterPage>
    </S.Root>
  );
}

export default StudioDashboard;